import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSidenav} from "@angular/material/sidenav";

@Component({
  selector: 'app-ramadan2022-header',
  templateUrl: './ramadan2022-header.component.html',
  styleUrls: ['./ramadan2022-header.component.scss']
})
export class Ramadan2022HeaderComponent implements OnInit {
  opened: boolean = false;
  @ViewChild('sidenav') sidenav: MatSidenav;
  reason = ''
  mobview = false
  constructor() { }

  ngOnInit(): void {
    if(window.screen.width >= 567){
      this.mobview = false
    }else{
      this.mobview = true
    }
  }

  toggle() {
    this.opened = !this.opened;

  }
  navigateTo() {
    this.opened = false;

  }
  close(reason: string) {
    this.reason = reason;
    this.sidenav.close();
  }
}
